const $$splitComponentImporter = () => import('/data/circle/current/app/javascript/react/tanstack_routes/_protected/_settingsLayout/settings/emails/broadcast/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { BROADCAST_TABS, TAB_QUERY_NAME } from "@circle-react/components/SettingsApp/Emails/components/Broadcasts/constants";
import { createFileRoute } from "@tanstack/react-router";
interface BroadcastSearch {
  page: number;
  [TAB_QUERY_NAME]: BroadcastStatusValue;
}
const isBroadcastTabType = (value: unknown): value is BroadcastStatusValue => BROADCAST_TABS.includes(value as BroadcastStatusValue);
export const Route = createFileRoute("/_protected/_settingsLayout/settings/emails/broadcast/")({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  validateSearch: (search: Partial<BroadcastSearch> & SearchSchemaInput): BroadcastSearch => {
    const rawStatus = search[TAB_QUERY_NAME];
    const status = isBroadcastTabType(rawStatus) ? rawStatus : BROADCAST_TABS[0];
    return {
      [TAB_QUERY_NAME]: status,
      page: Number(search.page) || 1
    };
  }
});